function isArrayFor(...args: any): boolean {
    for (const item of args) {
        if (!Array.isArray(item)) {
            return false;
        }
    }

    return true;
}

// ----------------------------------------------------------------------------

export default isArrayFor;
